import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shipd.svg'
import _imports_1 from '@/assets/xmark.svg'


const _withScopeId = n => (_pushScopeId("data-v-2e0038f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " To proceed please choose a plan that suites you, you are always able to change afterwards ", -1))
const _hoisted_5 = {
  key: 3,
  class: "plan-wrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "rec"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Recommended", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "price"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "comparePrice"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = { class: "plan-wrapper" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "price"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "comparePrice"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "modal-background"
}
const _hoisted_28 = { class: "confirm" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "conTxt" }, "Are you sure?", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "conTxt" }, " You are about to change your plan. This will immediately cancel your current subscription and the new one will begin. You will be charged accordingly. ", -1))
const _hoisted_31 = { class: "btn-wrapper" }
const _hoisted_32 = {
  key: 0,
  class: "modal-background"
}
const _hoisted_33 = { class: "confirm" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "conTxt" }, "Your new plan is now active", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cross-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_ToggleButtonModal = _resolveComponent("ToggleButtonModal")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_UpsellScreen = _resolveComponent("UpsellScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!$props.existingPlan && _ctx.$route.path != '/' && _ctx.$route.path != '/learn-more')
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (!$props.existingPlan)
        ? (_openBlock(), _createBlock(_component_ToggleButton, {
            key: 1,
            onChange: $setup.toggleEvent,
            labelEnableText: "Yearly",
            labelDisableText: "Monthly"
          }, null, 8, ["onChange"]))
        : _createCommentVNode("", true),
      ($props.existingPlan)
        ? (_openBlock(), _createBlock(_component_ToggleButtonModal, {
            key: 2,
            onChange: $setup.toggleEvent,
            labelEnableText: "Yearly",
            labelDisableText: "Monthly"
          }, null, 8, ["onChange"]))
        : _createCommentVNode("", true),
      ($setup.windowSize >= 995)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.products, (product, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index + '-product',
                class: _normalizeClass(["plan", { 'sub-plan': product.name != 'Chief Mate' }])
              }, [
                (product.name == 'Chief Mate')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("h1", null, _toDisplayString(product.name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.prices, (price, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: index + '-price'
                  }, [
                    (
                (!$setup.paymentPeriod && price.interval == 'year') ||
                ($setup.paymentPeriod && price.interval == 'month')
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (price.unit_amount != 0 && price.interval == 'year')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                (price.metadata.compare_price)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(`$${price.metadata.compare_price
                      .toString()
                      .slice(0, -2)}.${price.metadata.compare_price
                      .toString()
                      .slice(-2)}/mo`), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("h2", null, _toDisplayString(`$${(price.unit_amount / 12)
                      .toString()
                      .split(".")[0]
                      .slice(0, -2)}.${(price.unit_amount / 12)
                      .toString()
                      .split(".")[0]
                      .slice(-2)}/mo`), 1)
                              ]))
                            : (price.unit_amount != 0 && price.interval == 'month')
                              ? (_openBlock(), _createElementBlock("h2", _hoisted_12, _toDisplayString(`$${price.unit_amount
                    .toString()
                    .slice(0, -2)}.${price.unit_amount
                    .toString()
                    .slice(-2)}/${price.interval.substring(0, 2)}`), 1))
                              : _createCommentVNode("", true),
                          (price.unit_amount == 0 && price.active)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_13, "Free"))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(product.metadata)
                  .filter((meta) => meta != 'index')
                  .sort()
                  .reverse(), (feature, index) => {
                            return (_openBlock(), _createElementBlock("h1", {
                              key: index + '-feature'
                            }, _toDisplayString(`${$setup.getFeatureName(feature)} ${
                      product.metadata[feature] == "true"
                        ? "✅"
                        : product.metadata[feature] == "false"
                        ? "❌"
                        : product.metadata[feature]
                    }`), 1))
                          }), 128)),
                          (price.unit_amount !== 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                _createTextVNode(_toDisplayString(`Billed per ${price.interval},`) + " ", 1),
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(`reoccurring payments`))
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.auth.currentUser)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (
                    (_ctx.$store.state.isPremium && product.name == 'Captain') ||
                    (!_ctx.$store.state.isPremium && product.name == 'Deck Cadet')
                  )
                                  ? (_openBlock(), _createElementBlock("h4", _hoisted_16, " Current plan "))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      disabled: $setup.isLoading,
                                      onClick: 
                    () => {
                      $setup.isChosen.product = product;
                      $setup.isChosen.price = price;
                      $props.existingPlan
                        ? ($setup.showConfirm = true)
                        : $setup.createSub(
                            price,
                            product,
                            $props.existingPlan ? true : false
                          );
                    }
                  
                                    }, " Choose plan ", 8, _hoisted_17))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 2))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.products, (product, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index + '-product',
                  class: _normalizeClass(["plan", { chosen: $setup.isChosen.product.id == product.id }]),
                  onClick: ($event: any) => ($setup.selectProduct(product))
                }, [
                  (product.name == 'Chief Mate')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["rec", {
                chosenRec: $setup.isChosen.product.id == product.id,
              }])
                      }, [
                        _createElementVNode("h3", {
                          class: _normalizeClass(["rec-txt", { chosenRecTxt: $setup.isChosen.product.id == product.id }])
                        }, " Recommended ", 2)
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("h1", null, _toDisplayString(product.name), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.prices, (price, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: index + '-price'
                    }, [
                      (
                  (!$setup.paymentPeriod && price.interval == 'year') ||
                  ($setup.paymentPeriod && price.interval == 'month')
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (price.unit_amount != 0 && price.interval == 'year')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                  (price.metadata.compare_price)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(`$${price.metadata.compare_price
                        .toString()
                        .slice(0, -2)}.${price.metadata.compare_price
                        .toString()
                        .slice(-2)}/mo`), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("h2", null, _toDisplayString(`$${(price.unit_amount / 12)
                        .toString()
                        .split(".")[0]
                        .slice(0, -2)}.${(price.unit_amount / 12)
                        .toString()
                        .split(".")[0]
                        .slice(-2)}/mo`), 1)
                                ]))
                              : (
                    price.unit_amount != 0 && price.interval == 'month'
                  )
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_23, _toDisplayString(`$${price.unit_amount
                      .toString()
                      .slice(0, -2)}.${price.unit_amount
                      .toString()
                      .slice(-2)}/${price.interval.substring(0, 2)}`), 1))
                                : _createCommentVNode("", true),
                            (price.unit_amount == 0 && price.active)
                              ? (_openBlock(), _createElementBlock("h2", _hoisted_24, "Free"))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(product.metadata)
                    .filter((meta) => meta != 'index')
                    .sort()
                    .reverse(), (feature, index) => {
                              return (_openBlock(), _createElementBlock("h3", {
                                key: index + '-feature'
                              }, _toDisplayString(`${$setup.getFeatureName(feature)} ${
                        product.metadata[feature] == "true"
                          ? "✅"
                          : product.metadata[feature] == "false"
                          ? "❌"
                          : product.metadata[feature]
                      }`), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 10, _hoisted_19))
              }), 128))
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(`Billed per ${$setup.paymentPeriod ? "month" : "year"},`) + " ", 1),
              _hoisted_25,
              _createTextVNode(" " + _toDisplayString(`reoccurring payments`))
            ]),
            ($setup.auth.currentUser)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (
            (!_ctx.$store.state.isPremium && $setup.isChosen.product.name == 'Captain') ||
            (_ctx.$store.state.isPremium && $setup.isChosen.product.name == 'Deck Cadet')
          )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = 
            () => {
              $props.existingPlan
                ? ($setup.showConfirm = true)
                : $setup.createSub(
                    $setup.isChosen.price,
                    $setup.isChosen.product,
                    $props.existingPlan ? true : false
                  );
            }
          )
                      }, " Continue "))
                    : (_openBlock(), _createElementBlock("h4", _hoisted_26, "Current plan"))
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.showConfirm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: "conBtn",
                  onClick: _cache[1] || (_cache[1] = 
              () => {
                $setup.createSub(
                  $setup.isChosen.price,
                  $setup.isChosen.product,
                  $props.existingPlan || _ctx.$route.path == '/' ? true : false
                );
              }
            )
                }, " Yes, change my plan "),
                _createElementVNode("button", {
                  class: "conBtn cancel",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showConfirm = false))
                }, " Cancel ")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.showComplete)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _hoisted_35,
              _createElementVNode("button", {
                class: "conBtn",
                onClick: _cache[3] || (_cache[3] = 
            () => {
              $setup.showComplete = false;
              $setup.close();
            }
          )
              }, " Perfect! ")
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.showUpsell)
        ? (_openBlock(), _createBlock(_component_UpsellScreen, {
            key: 0,
            products: $setup.products
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "cross",
                onClick: _cache[4] || (_cache[4] = () => ($setup.showUpsell = !$setup.showUpsell))
              }, _hoisted_37)
            ]),
            _: 1
          }, 8, ["products"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}